<template>
  <v-container>
    <v-row
      ><v-col cols="0" lg="0" xl="1"></v-col
      ><v-col cols="12" lg="12" xl="10">
        <div class="text-center pt-16" v-if="isLoading">
          <v-progress-circular
            indeterminate
            color="blue-grey darken-1"
          ></v-progress-circular>
        </div>
        <v-data-table
          v-if="!isLoading"
          ref="vDataTable"
          v-model="selected"
          :headers="headers"
          :items="desserts"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search"
          item-key="messageId"
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar
              :flat="offsetTop <= 0"
              style="
                position: sticky;
                top: 73px;
                background-color: #fff;
                z-index: 1;
              "
            >
              <v-toolbar-title>推播列表</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog persistent v-model="dialog" max-width="960px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue-grey"
                    dark
                    style="height: 40px"
                    class="mb-2 mt-2 mr-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    新增
                  </v-btn>
                  <v-btn
                    color="blue-grey lighten-1"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2 mr-2"
                    @click="next()"
                    v-if="lastVisible"
                  >
                    載入更多
                  </v-btn>
                  <v-spacer></v-spacer
                  ><v-btn
                    color="blue-grey"
                    style="height: 40px"
                    dark
                    class="mb-2 mt-2 ml-2"
                    @click="clearQuery()"
                  >
                    清除
                  </v-btn>
                  <v-btn
                    color="blue-grey"
                    dark
                    style="height: 40px"
                    class="mb-2 mt-2 ml-3"
                    @click="queryByUserNo()"
                  >
                    員編搜尋
                  </v-btn>
                  <!--<v-switch
                    v-model="singleExpand"
                    label="Single expand"
                    class="pa-3"
                  ></v-switch>
                  <v-switch
                    v-model="singleSelect"
                    label="Single select"
                    class="pa-3"
                  ></v-switch>-->
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </template>
                <v-card>
                  <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text
                    class="pt-6"
                    :class="{ 'edit-mode': !(editedIndex > -1) }"
                  >
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            :class="{
                              'col-md-4': editedIndex > -1,
                            }"
                          >
                            <!--<v-select
                              v-model="template.type"
                              :items="types"
                              label="分類"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-select>-->
                            <v-select
                              label="*種類"
                              v-model="template.type"
                              :items="types"
                              item-text="text"
                              item-value="value"
                              outlined
                              dense
                              hide-details="true"
                              :rules="[(v) => !!v]"
                              :disabled="editedIndex > -1"
                            ></v-select>
                            <!--<v-text-field
                            v-model="template.type"
                            label="種類"
                            hide-details="true"
                            dense
                            outlined
                            required
                          ></v-text-field>--></v-col
                          ><v-col
                            cols="12"
                            md="3"
                            v-if="!(editedIndex > -1)"
                            :class="{
                              'col-md-4': editedIndex > -1,
                            }"
                          >
                            <v-select
                              v-model="sendImmediately"
                              :items="isSendImmediately"
                              label="*立即發送"
                              hide-details="true"
                              dense
                              outlined
                              :rules="[(v) => !!v]"
                            ></v-select></v-col
                          ><v-col
                            cols="12"
                            md="3"
                            :class="{
                              'col-md-4': editedIndex > -1,
                            }"
                          >
                            <!--<v-text-field
                            v-model="template.scheduleSend"
                            label="傳送時間"
                            hide-details="true"
                            dense
                            outlined
                            required
                          ></v-text-field>-->
                            <v-menu
                              v-model="sendDateMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="template.scheduleSendDate[0]"
                                  label="*傳送日期"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  dense
                                  outlined
                                  hide-details="true"
                                  :rules="[
                                    (v) =>
                                      !!v ||
                                      !(
                                        editedIndex > -1 ||
                                        (sendImmediately != null &&
                                          !sendImmediately)
                                      ),
                                  ]"
                                  :disabled="
                                    !(
                                      sendImmediately != null &&
                                      !sendImmediately
                                    )
                                  "
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="template.scheduleSendDate[0]"
                                no-title
                                @input="sendDateMenu = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                            cols="12"
                            md="3"
                            :class="{
                              'col-md-4': editedIndex > -1,
                            }"
                          >
                            <v-menu
                              ref="sendTimeMenu"
                              v-model="sendTimeMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="template.scheduleSendDate[1]"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="template.scheduleSendDate[1]"
                                  label="*傳送時間"
                                  prepend-icon="mdi-clock-time-four-outline"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  dense
                                  outlined
                                  hide-details="true"
                                  :rules="[
                                    (v) =>
                                      !!v ||
                                      !(
                                        editedIndex > -1 ||
                                        (sendImmediately != null &&
                                          !sendImmediately)
                                      ),
                                  ]"
                                  :disabled="
                                    !(
                                      sendImmediately != null &&
                                      !sendImmediately
                                    )
                                  "
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="sendTimeMenu"
                                v-model="template.scheduleSendDate[1]"
                                full-width
                                @click:minute="
                                  $refs.sendTimeMenu.save(
                                    template.scheduleSendDate[1]
                                  )
                                "
                              ></v-time-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" class="col-md-6">
                            <v-text-field
                              v-model="template.sendTitle"
                              :counter="10"
                              label="*標題"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                              :disabled="editedIndex > -1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="col-md-6">
                            <v-text-field
                              v-model="template.redirectUrl"
                              label="鏈接網址"
                              hide-details="true"
                              dense
                              outlined
                              :disabled="editedIndex > -1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-textarea
                              v-model="template.sendMessage"
                              label="*內容"
                              hide-details="true"
                              rows="6"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                              :disabled="editedIndex > -1"
                            ></v-textarea>
                          </v-col> </v-row
                      ></v-form>
                      <v-row v-if="!(editedIndex > -1)">
                        <v-col cols="12" md="12">
                          <template>
                            <v-data-table
                              dense
                              v-model="usersSelected"
                              :search="searchUser"
                              :headers="usersHeaders"
                              :items="usersFilter"
                              :single-select="singleSelect"
                              item-key="userNo"
                              show-select
                              class="elevation-1"
                              :items-per-page="15"
                            >
                              <template v-slot:top>
                                <div
                                  class="d-flex justify-space-around align-center"
                                >
                                  <div
                                    class="text-h6 font-weight-bold grey--text text--darken-2 px-4 py-3 mt-0"
                                  >
                                    選擇傳送對象
                                  </div>
                                  <v-spacer></v-spacer>
                                  <v-text-field
                                    class="ma-0 mb-1 pa-0"
                                    v-model="searchUser"
                                    append-icon="mdi-magnify"
                                    label="Search"
                                    single-line
                                    hide-details
                                    dense
                                  ></v-text-field>

                                  <!--<v-switch
                                    v-model="genderFilter"
                                    label="性別過濾"
                                    class="pa-3 mt-0"
                                    hide-details="true"
                                    dense
                                  ></v-switch>--><v-btn
                                    color="blue-grey"
                                    dark
                                    small
                                    class="mb-2 mt-2 ml-2"
                                    @click="userQueryByUserNo()"
                                  >
                                    員編搜尋
                                  </v-btn>
                                  <v-spacer></v-spacer>
                                  <v-checkbox
                                    v-model="genderFilter"
                                    label="男生"
                                    value="男生"
                                    class="pa-3 mt-0"
                                    hide-details="true"
                                    dense
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="genderFilter"
                                    label="女生"
                                    value="女生"
                                    class="pa-3 mt-0"
                                    hide-details="true"
                                    dense
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="genderFilter"
                                    label="其他"
                                    value=""
                                    class="pa-3 mt-0"
                                    hide-details="true"
                                    dense
                                  ></v-checkbox>
                                  <!--<v-switch
                                    v-model="singleSelect"
                                    label="Single select"
                                    class="pa-3 mt-0"
                                  ></v-switch>-->
                                </div>
                              </template>
                            </v-data-table>
                            <v-combobox
                              v-model="usersSelected"
                              chips
                              label="已選擇的人員"
                              multiple
                              solo
                              hide-details="true"
                              class="mt-4"
                            >
                              <template
                                v-slot:selection="{
                                  attrs,
                                  item,
                                  select,
                                  selected,
                                }"
                              >
                                <v-chip
                                  v-bind="attrs"
                                  :input-value="selected"
                                  close
                                  @click="select"
                                  @click:close="remove(item)"
                                >
                                  <strong>{{ item.userNo }}</strong
                                  >&nbsp;
                                </v-chip>
                              </template>
                            </v-combobox>
                          </template>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      {{ !(editedIndex > -1) ? "取消" : "關閉" }}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      v-if="!(editedIndex > -1)"
                      text
                      @click="save"
                    >
                      儲存
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5">確定要移除此項目?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >取消</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >確認</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.sendTitle`]="{ item }">
            {{ item.sendTitle.trim().substr(0, 40) }}
          </template>
          <template v-slot:[`item.sendMessage`]="{ item }">
            {{ item.sendMessage.trim().substr(0, 40) }}...
          </template>
          <template v-slot:[`item.scheduleSendDate`]="{ item }">
            {{ item.scheduleSendDate[0] }} {{ item.scheduleSendDate[1] }}
          </template>
          <template v-slot:[`item.redirectUrl`]="{ item }">
            <v-btn icon :href="item.redirectUrl" target="_blank">
              <v-icon> mdi-link </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.alreadySend`]="{ item }">
            <v-simple-checkbox
              v-model="item.alreadySend"
              class="ml-3"
              :ripple="false"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.alreadyRead`]="{ item }">
            <v-simple-checkbox
              v-model="item.alreadyRead"
              class="ml-3"
              :ripple="false"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.actionsEdit`]="{ item }">
            <v-icon @click="editItem(item)" style="font-size: 19px">
              mdi-eye
            </v-icon>
            <!--<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>-->
          </template>
          <template v-slot:[`item.actionsDel`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template v-slot:[`item.data-table-expand`]="props">
            <v-icon
              :class="{
                'v-data-table__expand-icon': true,
                'v-data-table__expand-icon--active':
                  props.isExpanded && transitioned[getItemId(props.item)],
              }"
              @click="toggleExpand(props)"
            >
              mdi-chevron-down
            </v-icon>
          </template>

          <!--展開內容-->
          <template v-slot:[`expanded-item`]="{ headers, item }">
            <td
              :colspan="headers.length"
              :class="{
                'ma-0 pa-0': true,
                'expanded-closing': !transitioned[getItemId(item)],
              }"
              style="height: auto"
            >
              <v-expand-transition>
                <div v-show="transitioned[getItemId(item)]">
                  <div class="pa-2" style="min-height: 100px">
                    <!--<span>{{ item }}</span>-->
                    <v-form>
                      <v-container class="my-6">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-img
                              style="
                                filter: grayscale(0.8);
                                width: 98%;
                                max-width: 1000px;
                              "
                              :lazy-src="
                                item.mainPictureUrl
                                  ? item.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              :src="
                                item.mainPictureUrl
                                  ? item.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              cover
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="8">
                            <div class="d-flex justify-space-between">
                              <div>
                                <div
                                  class="grey--text text--darken-1 text-subtitle-2 mb-2 font-weight-regular"
                                >
                                  活動日期 {{ item.startDate }} -
                                  {{ item.startDate }}
                                </div>
                                <p
                                  class="text-h4 font-weight-black text--primary mb-1"
                                >
                                  {{ item.storeName }}
                                </p>
                                <div
                                  class="font-weight-black font-weight-medium grey--text text--darken-2 text-h6 mb-10"
                                >
                                  台南市
                                </div>
                              </div>
                              <div>
                                <v-img
                                  max-width="200"
                                  style="opacity: 0.5"
                                  :lazy-src="
                                    item.logoUrl
                                      ? item.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                  :src="
                                    item.logoUrl
                                      ? item.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                ></v-img>
                              </div>
                            </div>
                            <hr
                              class="v-divider theme--light border-dashed mb-4"
                              style="border-style: dashed"
                            />
                            <v-row>
                              <v-col cols="12" md="6">
                                <p
                                  class="text-subtitle-2 font-weight-black mb-1"
                                >
                                  網站
                                </p>
                                <div
                                  class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                  style="word-break: break-all"
                                >
                                  {{ item.webSiteUrl }}
                                </div>
                                <p
                                  class="text-subtitle-2 font-weight-black mb-1"
                                >
                                  電話
                                </p>
                                <div
                                  class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                >
                                  {{ item.phone }}
                                </div>
                                <p
                                  class="text-subtitle-2 font-weight-black mb-1"
                                >
                                  簡介
                                </p>
                                <div
                                  class="text-subtitle-1 grey--text text--darken-2 mb-2"
                                  style="
                                    text-align: justify;
                                    word-break: break-all;
                                  "
                                >
                                  {{ item.description }}
                                </div>
                              </v-col>
                              <v-col cols="6"
                                ><v-row no-gutters>
                                  <v-col cols="12" md="6">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      編號
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      No.{{ item.storeNo }}
                                    </div></v-col
                                  ><v-col cols="12" md="6">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      分類
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      住
                                    </div></v-col
                                  >
                                </v-row>
                                <v-row no-gutters>
                                  <v-col cols="12" md="6">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      啟用
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      {{ item.shouldDisplay }}
                                    </div></v-col
                                  ><v-col cols="12" md="6">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      到期
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-2"
                                    >
                                      {{ item.expired }}
                                    </div></v-col
                                  >
                                </v-row>
                                <p
                                  class="text-subtitle-2 font-weight-black mb-1"
                                >
                                  座標
                                </p>
                                <div
                                  class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                >
                                  緯度 : {{ item.lat
                                  }}<v-spacer></v-spacer> 經度 :
                                  {{ item.lng }}
                                </div>
                              </v-col>
                            </v-row></v-col
                          >
                        </v-row>
                      </v-container>
                    </v-form>
                  </div>
                </div>
              </v-expand-transition>
            </td>
          </template>
        </v-data-table></v-col
      ><v-col cols="0" lg="0" xl="1"></v-col
    ></v-row>
  </v-container>
</template>

<script>
import { db, functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import {
  query,
  where,
  collection,
  getDocs,
  setDoc,
  doc,
  deleteDoc,
  documentId,
  orderBy,
  startAfter,
  limit,
} from "firebase/firestore/lite";

export default {
  data: () => ({
    offsetTop: 0,
    isLoading: true,
    sendTimeMenu: false,
    sendImmediately: null,
    isSendImmediately: [true, false],
    valid: true,
    sendDateMenu: false,
    search: "",
    searchUser: "",
    singleSelect: false,
    selected: [],
    expanded: [],
    singleExpand: false,
    dialog: false,
    dialogDelete: false,
    types: [
      { text: "生日禮", value: "birthdayGift" },
      { text: "新店家上架", value: "newStore" },
      { text: "禮券", value: "gift" },
      { text: "公告", value: "notify" },
    ],
    headers: [
      { text: "編號", value: "messageId", width: "8%" },
      { text: "分類", align: "start", value: "type", width: "8%" },
      { text: "標題", align: "start", value: "sendTitle" },
      {
        text: "內容",
        align: "start",
        value: "sendMessage",
      },
      { text: "預計寄送日", value: "scheduleSendDate", width: "12%" },
      { text: "對象", value: "userNo", width: "8%" },
      {
        text: "寄送",
        value: "alreadySend",
        align: "center",
        sortable: false,
        width: "6%",
      },
      {
        text: "已讀",
        value: "alreadyRead",
        align: "center",
        sortable: false,
        width: "6%",
      },
      {
        text: "網址",
        align: "center",
        value: "redirectUrl",
        sortable: false,
        width: "6%",
      },
      {
        text: "檢視",
        value: "actionsEdit",
        sortable: false,
        align: "center",
        width: "6%",
      },
      {
        text: "刪除",
        value: "actionsDel",
        sortable: false,
        align: "center",
        width: "6%",
      },
    ],
    usersSelected: [],
    usersHeaders: [
      { text: "所屬公司", value: "compName" },
      { text: "公司編號", value: "compNo" },
      { text: "員工編號", value: "userNo" },
      { text: "性別", value: "gender" },
      { text: "手機號碼", value: "phoneNumber" },
    ],
    desserts: [],
    users: [],
    editedIndex: -1,
    defaultItem: { scheduleSendDate: [] },
    template: { scheduleSendDate: [] },
    transitioned: [],
    closeTimeouts: {},
    genderFilter: ["男生", "女生", ""],
    usersFilter: [],
    lastVisible: {},
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    singleExpand(v) {
      if (!v) return;
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
    genderFilter() {
      if (this.genderFilter.length >= 3) {
        this.usersFilter = this.users;
      } else {
        let result = this.users.filter((item) =>
          this.genderFilter.includes(item.gender)
        );
        this.usersFilter = result;
      }
    },
  },

  created() {
    this.$bus.$emit("sideBarSelectedItem:push", 7);
    this.getMessages();
    this.getUsers();
    // fetch(
    //   "https://us-central1-pec-eps-4819c.cloudfunctions.net/sendMessageToken",
    //   {
    //     method: "POST",

    //     body: JSON.stringify({
    //       USER_ID: "11010059,11010160,87094024",
    //       DEVICE_OS: "IOS,ANDROID",
    //       PUSH_TITLE: "Test iOS .p8 EPS token",
    //       PUSH_BODY: "as title",
    //       PUSH_REDIRECT: "https://unilife.pec.com.tw",
    //     }),
    //   }
    // )
    //   .then((res) => res.json())
    //   .then((data) => {
    //     console.log("??", data);
    //   });
    // console.log(this.formatDate(new Date()));
    // console.log(this.formatTime(new Date()));
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    // async test() {
    //   const rawResponse = await fetch(
    //     "https://us-central1-pec-eps-4819c.cloudfunctions.net/sendMessageToken",
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify({
    //         USER_ID: "11010160",
    //         DEVICE_OS: "ANDROID",
    //         PUSH_TITLE: "7777777777777",
    //         PUSH_BODY: "777777777777",
    //         PUSH_REDIRECT: "https://unilife.pec.com.tw",
    //         BADGE: 1,
    //       }),
    //     }
    //   );
    //   const content = await rawResponse.json();
    // },
    test() {
      const callSendMessageToken = httpsCallable(
        functions,
        "callSendMessageToken"
      );
      callSendMessageToken({
        USER_ID: "11010160",
        PUSH_TITLE: "call 15:14",
        PUSH_BODY: "as title",
        PUSH_REDIRECT: "https://unilife.pec.com.tw",
      }).then((result) => {
        const data = result.data;
        console.log(data);
      });
    },
    async userQueryByUserNo() {
      if (this.searchUser) {
        this.users = [];
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("userNo", "==", this.searchUser));
        const documentSnapshots = await getDocs(q);
        documentSnapshots.forEach((doc) => {
          let data;
          data = JSON.parse(JSON.stringify(doc.data()));
          console.log(doc.id, " => ", doc.data());
          if (data.createTime) {
            this.users.push(data);
          }
        });
        this.usersFilter = this.users;
        if (this.users.length === 0) {
          this.$snackbar.add(`暫時沒有符合的資料`, { color: "error" });
        }
      }
    },
    userClearQuery() {
      this.users = [];
      this.usersFilter = [];
      this.searchUser = "";
      // this.getUsers();
    },
    async queryByUserNo() {
      if (this.search) {
        this.desserts = [];
        const usersRef = collection(db, "messages");
        const q = query(usersRef, where("userNo", "==", this.search));
        const documentSnapshots = await getDocs(q);
        documentSnapshots.forEach((doc) => {
          let data;
          data = JSON.parse(JSON.stringify(doc.data()));
          console.log(doc.id, " => ", doc.data());
          this.desserts.push(data);
        });
        if (this.desserts.length === 0) {
          this.$snackbar.add(`暫時沒有符合的資料`, { color: "error" });
        }
      }
    },
    clearQuery() {
      this.desserts = [];
      this.search = "";
      this.getMessages();
    },
    async getUsers() {
      const first = query(
        collection(db, "users"),
        orderBy("createTime", "desc"),
        limit(15)
      );
      const documentSnapshots = await getDocs(first);
      console.log(documentSnapshots);
      documentSnapshots.forEach((doc) => {
        let data;
        data = JSON.parse(JSON.stringify(doc.data()));
        console.log(doc.id, " => ", doc.data());
        this.users.push(data);
      });

      this.usersFilter = this.users;
    },
    // async getMessages() {
    //   const querySnapshot = await getDocs(collection(db, "messages"));
    //   querySnapshot.forEach((doc) => {
    //     // doc.data() is never undefined for query doc snapshots
    //     // console.log(doc.id, " => ", doc.data());
    //     this.desserts.push(doc.data());
    //     this.desserts.sort((a, b) => {
    //       return b.createTime - a.createTime;
    //     });
    //   });
    //   this.isLoading = false;
    // },
    async getMessages() {
      const first = query(
        collection(db, "messages"),
        orderBy("createTime", "desc"),
        limit(50)
      );
      const documentSnapshots = await getDocs(first);
      console.log(documentSnapshots);
      documentSnapshots.forEach((doc) => {
        let data;
        data = JSON.parse(JSON.stringify(doc.data()));
        console.log(doc.id, " => ", doc.data());
        this.desserts.push(data);
      });

      this.lastVisible =
        documentSnapshots.docs[documentSnapshots.docs.length - 1];
      this.isLoading = false;
    },
    async next() {
      if (this.lastVisible) {
        const next = query(
          collection(db, "messages"),
          orderBy("createTime", "desc"),
          startAfter(this.lastVisible),
          limit(50)
        );

        const documentSnapshots = await getDocs(next);

        if (documentSnapshots.docs.length == 0) {
          this.$snackbar.add(`沒有更多了`, { color: "success" });
          this.lastVisible = "";
        } else if (documentSnapshots.docs.length < 50) {
          this.lastVisible = "";
        } else {
          this.lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 1];
        }

        documentSnapshots.forEach((doc) => {
          let data;
          data = JSON.parse(JSON.stringify(doc.data()));
          console.log(doc.id, " => ", doc.data());
          this.desserts.push(data);
        });
      } else {
        this.$snackbar.add(`沒有更多了`, { color: "success" });
        this.lastVisible = "";
      }
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      const q = query(
        collection(db, "messages"),
        where(documentId(), "==", this.template.messageId)
      );

      const querySnapshot = await getDocs(q);
      await deleteDoc(doc(db, "messages", querySnapshot._docs[0].id));
      this.$snackbar.add(`刪除成功`, { color: "success" });
      this.desserts = [];
      this.getMessages();
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
        this.usersSelected = [];
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (this.usersSelected.length > 0) {
          if (this.editedIndex > -1) {
            console.log("修改");
          } else {
            let data = { scheduleSendDate: [] };
            console.log("新增");
            data.alreadyRead = false;
            data.createTime = Number(this.timest());
            data.type = this.template.type;
            data.sendMessage = this.template.sendMessage;
            data.sendTitle = this.template.sendTitle;
            if (this.template.redirectUrl) {
              data.redirectUrl = this.template.redirectUrl;
            } else {
              data.redirectUrl = "";
            }
            data.actualSendTime = 0;
            data.alreadySend = false;

            if (this.sendImmediately) {
              data.scheduleSendDate[0] = this.formatDate(new Date());
              data.scheduleSendDate[1] = this.formatTime(new Date());
              data.scheduleSendTime = Number(this.timest());
            } else {
              data.scheduleSendDate[0] = this.template.scheduleSendDate[0];
              data.scheduleSendDate[1] = this.template.scheduleSendDate[1];

              let dateToConvert = `${data.scheduleSendDate[0]} ${data.scheduleSendDate[1]}:00`;
              let date = new Date(dateToConvert);
              let timestamp = date.getTime();

              data.scheduleSendTime = Number(
                timestamp.toString().substr(0, 10)
              );
            }

            await Promise.all(
              this.usersSelected.map((item) => {
                let createdId = doc(collection(db, "env")).id;
                data.messageId = createdId;
                data.userNo = item.userNo;
                data.compNo = item.compNo;
                return setDoc(doc(db, "messages", createdId), data);
              })
            );

            this.usersSelected = [];
            this.desserts = [];
            this.getMessages();
            this.$snackbar.add(`修改完成`, { color: "success" });
            this.close();
          }
        } else {
          this.$snackbar.add(`未選取傳送對象`, { color: "error" });
        }
      }
    },
    getItemId(item) {
      return item.messageId; // Must be uid of record (would be nice if v-data-table exposed a "getItemKey" method)
    },
    toggleExpand(props) {
      const item = props.item;
      const id = this.getItemId(item);
      if (props.isExpanded && this.transitioned[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpand(item);
      } else {
        // If we're closed or in the process of closing, expand
        // Stop us from closing if a close transition was started
        clearTimeout(this.closeTimeouts[id]);
        // Tell v-data-table to add the expansion content for the item
        props.expand(true);
        // Show expansion content with transition animation after it's had time to get added to the DOM
        this.$nextTick(() => this.$set(this.transitioned, id, true));
        // Hide all other expanded items if single-expand
        if (this.singleExpand)
          this.$nextTick(() =>
            this.expanded.forEach((i) => i !== item && this.closeExpand(i))
          );
      }
    },
    closeExpand(item) {
      const id = this.getItemId(item);
      // Mark that this item is in the process of closing
      this.$set(this.transitioned, id, false);
      // Remove expansion content from DOM after transition animation has had enough time to finish
      this.closeTimeouts[id] = setTimeout(
        () => this.$refs.vDataTable.expand(item, false),
        600
      );
    },
    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000);
      var year = a.getFullYear();
      var month = a.getMonth() + 1;
      var date = a.getDate();
      var time =
        year +
        "-" +
        month.toString().padStart(2, "0") +
        "-" +
        date.toString().padStart(2, "0");
      return time;
    },
    timest() {
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);
      return tmp;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours().toString().padStart(2, "0"),
        minute = d.getMinutes().toString().padStart(2, "0");

      return [hour, minute].join(":");
    },
    handleScroll() {
      this.offsetTop = window.scrollY;
    },
  },
};
</script>
<style>
.edit-mode {
  height: 77.1vh;
  overflow: auto;
}
</style>
